<template>
<div id="userInfoEdit-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="userInfoEdit-modalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="userInfoEdit-modalLabel">정보 수정</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="mb-3 text-center">
                    <img :src="userInfo.image_url" class="rounded-circle avatar-lg img-thumbnail object-fit-cover" alt="profile-image">
                    <p class="text-muted font-14"></p>
                    <button type="button" class="btn btn-outline-info me-1" @click="openUpload()">
                        <i class="mdi mdi-account-box-multiple-outline"></i> 사진 변경
                        <input type="file" id="userInfoImg" accept="image/*" style="display:none;" @change="selectImage($event)" />
                    </button>
                    <button type="button" class="btn btn-outline-danger" @click="deleteImage()">
                        <i class="mdi mdi-account-remove-outline"></i> 사진 삭제
                    </button>
                </div>
                <div class="mb-3">
                    <label for="email" class="form-label">이메일 <span class="text-danger">*</span></label>
                    <input class="form-control" type="email" id="email" placeholder="이메일을 입력해주세요" v-model="userInfo.email" readonly>
                    <label class="font-13 text-muted fw-light mt-1">이메일은 변경이 불가능합니다.</label>
                </div>
                <div class="mb-3">
                    <label for="name" class="form-label">원장님 성함 <span class="text-danger">*</span></label>
                    <input class="form-control" type="text" id="name" placeholder="원장님 성함을 입력해주세요" v-model="userInfo.name" @blur="checkName()">
                    <div class="invalid-feedback">
                        {{ errMsg.name }}
                    </div>
                </div>
                <div class="mb-3">
                    <label for="phone_no" class="form-label">휴대폰 번호 <span class="text-danger">*</span></label>
                    <div class="input-group input-group-merge">
                        <input class="form-control" type="tel" id="phone_no" placeholder="휴대폰 번호를 입력해주세요" v-model="userInfo.phone_no" @blur="checkPhoneNo()">
                        <button class="btn btn-primary" @click="changePhoneNo()">
                            <i class="mdi mdi-email-send-outline"></i>
                            휴대폰 번호 변경
                        </button>
                        <div class="invalid-feedback">
                            {{ errMsg.phone_no }}
                        </div>
                    </div>
                    <label class="font-13 text-muted fw-light mt-1">변경 시, 휴대폰 번호 인증이 필요합니다.</label>
                </div>
                <div class="mb-3" v-if="receive.verify_number">
                    <label for="verify_number" class="form-label">인증번호</label>
                    <div class="input-group input-group-merge">
                        <input class="form-control" type="text" id="verify_number" placeholder="인증번호를 입력해주세요" maxlength="4" v-model="verify_number" @blur="checkVerifyNumber()">
                        <button class="btn btn-primary" @click="confirmVerifyNumber(true, false);">
                            <i class="mdi mdi-email-check-outline"></i>
                            확인
                        </button>
                        <div class="invalid-feedback">
                            {{ errMsg.verify_number }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" @click="editUserInfo()">수정</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import common from "@/mixins/common.js";
import validation from "@/mixins/validation.js";

export default {
    props: ["userInfo", "receive", "errMsg"],
    mixins: [common, validation],
    data() {
        return {
            verify_number: "", // 사용자가 입력한 인증번호 4자리
            isVeryfied: false
        }
    },
    methods: {
        openUpload() {
            document.getElementById("userInfoImg").click();
        },
        async selectImage(event) {

            const files = event.target.files;
            const sendData = new FormData();

            if (!files || files.length === 0) {
                return;
            }

            for (let i = 0; i < files.length; i++) {
                if (!files[i].type.includes("image")) {
                    alert("유저 사진은 이미지 파일만 등록 가능합니다.");
                    return;
                }
                sendData.append("filedata", files[i]);
            }

            try {
                this.loadingOverlay(true);

                const result = await this.axios.post("/upload/tempUploadOriginal", sendData);
                this.userInfo.image_url = result.data[0];
            } catch (error) {
                console.log(error);
                alert("이미지 업로드 중 예기치 못한 에러가 발생하였습니다.\n다시 시도해주세요.");
            } finally {
                this.loadingOverlay(false);
            }
        },
        deleteImage() {
            if (confirm("해당 이미지를 삭제하시겠습니까?")) {
                this.userInfo.image_url = this.$store.state.defaultImageUrl;
            }
        },
        comparePhoneNo() {
            return this.receive.phone_no === this.userInfo.phone_no;
        },
        changePhoneNo() {
            this.comparePhoneNo() ? alert("현재 사용중이신 휴대폰 번호입니다.") : this.sendVerifyNumber(true);
        },
        editUserInfo() {
            // 핸드폰 번호 변경 인증을 진행한 경우 인증번호 까지 Check
            if (this.receive.verify_number) {
                const pass = [this.checkName(), this.checkPhoneNo(), this.checkVerifyNumber()].filter(i => !i);

                if (pass.length <= 0 && this.confirmVerifyNumber(false)) {
                    this.emitUserInfo();
                }

            } else { // 핸드폰 번호 변경 인증을 진행하지 않은 경우 (기존의 폰 번호랑 다른지만 Check)
                const pass = [this.checkName(), this.checkPhoneNo()].filter(i => !i);

                if (pass.length <= 0) {
                    if (this.comparePhoneNo()) {
                        this.emitUserInfo();
                    } else {
                        alert("휴대폰 번호가 변경되었습니다.\n인증을 진행해주세요.");
                    }
                }
            }
        },
        emitUserInfo() {
            this.axios.put("/user", this.userInfo).then(() => {
                alert("회원 정보가 정상적으로 변경되었습니다.");

                $("#userInfoEdit-modal").modal("hide");
                this.$emit("edit-parent-userInfo", this.userInfo);
            }).catch(err => {
                console.log(err);
            });
        }
    }
}
</script>
